import Vue from 'vue'
import VueRouter from 'vue-router'

// Views
import Complaints from '../../../components/view-complaints.vue';
import Complaint from '../../../components/view-complaint.vue';
import CustomerMachine from '../../../components/view-customer-machine.vue';

Vue.use(VueRouter)

const Router = (options) => {
  const routes = [
    { path: '/', name: 'complaints', component: Complaints },
    { path: '/:id', name: 'complaint', component: Complaint },
    { path: '/customer-machines/:serialNumber', name: 'customer-machine', component: CustomerMachine, beforeEnter(to, from, next) {
      const externalPage = options.pages && options.pages[to.name];
      if(externalPage) {
        location.href = externalPage.url + to.params.serialNumber;
        return;
      }
      next();
    }}
  ];

  const router =  new VueRouter({
    mode: 'history',
    base: options.base,
    linkActiveClass: 'v-router-link__active',
    linkExactActiveClass: 'v-router-link__current',
    routes: routes
  });

  return router;
}

export default Router;
